// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2ImageView-Mc2ImageView-module__imgViewBox--C5OZn {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  min-width: 10%;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2ImageView-Mc2ImageView-module__drag--ilLnX {
  width: 8px;
  background: #f0f0f0;
  cursor: col-resize;
  display: flex;
  align-items: center;
  justify-content: center;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2ImageView-Mc2ImageView-module__dragCenter--Pbby0 {
  width: 4px;
  height: 50%;
  max-height: 56px;
  border-radius: 4px;
  background: #bfbfbf;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2ImageView-Mc2ImageView-module__body--_vN5Y {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  width: 100%;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2ImageView-Mc2ImageView-module__body--_vN5Y > * {
  max-width: 100%;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsMeasurementChart2/Mc2Summary/Mc2Entity/Mc2ImageView/Mc2ImageView.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AACF;AACA;EACE,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACA;EACE,UAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AACF;AACA;EACE,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AACF;AAAE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAEJ","sourcesContent":[".imgViewBox {\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: row;\n  min-width: 10%;\n}\n.drag {\n  width: 8px;\n  background: #f0f0f0;\n  cursor: col-resize;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.dragCenter {\n  width: 4px;\n  height: 50%;\n  max-height: 56px;\n  border-radius: 4px;\n  background: #bfbfbf;\n}\n.body {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 8px;\n  width: 100%;\n  & > * {\n    max-width: 100%;\n    max-height: 100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imgViewBox": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2ImageView-Mc2ImageView-module__imgViewBox--C5OZn`,
	"drag": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2ImageView-Mc2ImageView-module__drag--ilLnX`,
	"dragCenter": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2ImageView-Mc2ImageView-module__dragCenter--Pbby0`,
	"body": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2ImageView-Mc2ImageView-module__body--_vN5Y`
};
export default ___CSS_LOADER_EXPORT___;
